import { render, staticRenderFns } from "./communicationDashboardPush.vue?vue&type=template&id=393cf0b6&scoped=true"
import script from "./communicationDashboardPush.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPush.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardPush.vue?vue&type=style&index=0&id=393cf0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393cf0b6",
  null
  
)

export default component.exports